export const domainReplace = (key: string) => {
  return window.location.origin.replace('www', key).replace('testnet', key);
};
